<template>
    <div>
        <h2>Was wurde beschädigt?</h2>
        <ion-grid>
            <ion-row>
                <ion-col size="10" offset="2">
                    <checkbox-group
                        :checkboxes="checkboxes"
                        @change="entstandenerschaden = $event.join(', ')"
                    />
                    <base-textarea
                        id="schaden-sonstiger"
                        v-model="schadenBeschreibung"
                        label="Beschreibung sonstiger Schaden"
                        v-if="hasSchadenBeschreibung"
                    ></base-textarea>
                </ion-col>
            </ion-row>
        </ion-grid>
        <div class="ion-text-right">
            <ion-button
                class="-round -add-padding ion-margin-top"
                :disabled="
                    entstandenerschaden === '' && schadenBeschreibung === ''
                "
                @click="
                    $emit('change', [
                        {
                            id: 'entstandenerschaden',
                            value: entstandenerschaden,
                        },
                        {
                            id: 'schadenBeschreibung',
                            value: schadenBeschreibung,
                        },
                        {
                            id: 'hasSchadenBeschreibung',
                            value: hasSchadenBeschreibung,
                        },
                    ])
                "
                >Weiter</ion-button
            >
        </div>
    </div>
</template>

<script>
import CheckboxGroup from "@/components/CheckboxGroup";
import BaseTextarea from "@/components/BaseTextarea";

export default {
    components: {
        CheckboxGroup,
        BaseTextarea,
    },
    data() {
        return {
            checkboxes: [
                { value: false, label: "Gebäude" },
                { value: false, label: "Einrichtung" },
                { value: false, label: "Warenlager" },
                { value: false, label: "Bargeld" },
                { value: false, label: "Wertgegenstände" },
                { value: false, label: "Sonstiges" },
            ],
            entstandenerschaden: "",
            schadenBeschreibung: "",
        };
    },
    computed: {
        hasSchadenBeschreibung() {
            let result = false;
            if (this.entstandenerschaden.includes("Sonstiges")) {
                result = true;
            }
            return result;
        },
    },
};
</script>

<style></style>
